import React, { useEffect } from 'react';
import { BsCameraReelsFill } from "react-icons/bs";
import { FiSend } from "react-icons/fi";
import { GrMicrophone } from "react-icons/gr";
import { MdAttachFile } from "react-icons/md";
import { PiFilmReelFill } from "react-icons/pi";
import { useLocation, useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import '../styles/loading.css';
import { baseUrl } from '../config';



const Loading = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const inputValue = location.state?.inputValue || '';

  // Genre to background mapping
  const genreBackgrounds = {
    'action': `url(${require('../assets/img/action.png')}) no-repeat center cover`, // Red and orange
    'comedy': 'linear-gradient(to right, #fffc00, #ffdd00)', // Yellow
    'drama': 'linear-gradient(to right, #4b79a1, #283e51)', // Blue and dark
    'horror': 'linear-gradient(to right, #0f2027, #203a43, #2c5364)', // Dark shades
    'romance': 'linear-gradient(to right, #ff6a88, #ff4466)', // Pink and red
    'sci-fi': 'linear-gradient(to right, #00c6ff, #0072ff)', // Light and dark blue
  };

  const genre = inputValue.toLowerCase();
  const backgroundStyle = genreBackgrounds[genre] || 'linear-gradient(to right, #ffffff, #cccccc)'; // Default background

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/chatbot',{ state: { backgroundStyle } }); 
    }, 3000); 
    return () => clearTimeout(timer); 
  }, [navigate]);
  return (
    <div className='loading' style={{ background: backgroundStyle }}>
      <SEO
        title="Loading"
        description="ProducerBuddy is loading your film production workspace."
        url="https://producerbuddy.pilomation.com"
        robots="noindex, nofollow"
      />
      <div className='script_loading'>
        <BsCameraReelsFill style={{ fontSize: '36px' }}/>
        <PiFilmReelFill className="reel-animation" style={{ fontSize: '20px'}} />
        <PiFilmReelFill className="reel-animation" style={{ fontSize: '20px' }}/>
        <PiFilmReelFill className="reel-animation" style={{ fontSize: '20px' }}/>
      </div>
      <div className='ai_script_bar'>
        <div className='input-wrapper'>
          <input type='text' placeholder='Type here...' value={inputValue} readOnly/>
          <GrMicrophone className='input-icon microphone-icon' />
          <MdAttachFile className='input-icon attach-icon' />
          <FiSend className='input-icon send-icon mx-2' />
        </div>
      </div>
    </div>
  );
}

export default Loading;

